import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
// 数据源
import { ListStore } from '../../store';
import { setlocal, getlocal } from '@src/utils';
// 组件
import VideoWrap from './VideoWrap';
// 秒数转时间格式
import { i2s } from '@src/utils/format';
import dayjs from 'dayjs';

const Header = ({ content }) => {
    // 列表数据源
    const listStore = ListStore.useContainer();
    const { listStates } = listStore;
    const { currentVideo } = listStates;

    useEffect(
        () => {
            if (currentVideo.videoPlayUrl) {
                const { dramaSeries, params, positive } = content;

                const history = getlocal('history');

                // 本地记录为空，创建新数据（新用户）
                if (!history) {
                    // alert('本地记录为空，创建新数据');
                    const data = [
                        {
                            id: params.id, // base62Id格式
                            title: dramaSeries.title,
                            // 点赞
                            like: false,
                            createTime: new Date(),
                            total: positive.length, // 总集数
                            currentIndex: '0', // 观看当前正片索引
                            extText: positive[0]?.extText,
                            posterUrl: dramaSeries.posterUrl || '', // 剧集封面
                            videoSeries: [
                                // 列表（正片/花序）
                                {
                                    id: currentVideo.base62Id, // base62Id格式
                                    type: 'positive', // 默认正片 positive / 花序 gags
                                    title: currentVideo.title2 ? currentVideo.title2 : currentVideo.title,
                                    thumbnail: currentVideo.thumbnails.image[0].url,
                                    duration: currentVideo.duration ? i2s(currentVideo.duration) : '00:00',
                                    currentTime: '0',
                                    createTime: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
                                },
                            ],
                        },
                    ];

                    setlocal('history', data);
                } else {
                    // 本地记录有数据
                    // alert('本地记录有数据');
                    const historyObj = JSON.parse(JSON.stringify(history));
                    const dramaSeriesData = historyObj.find(item => item.id === params.id);

                    // 存在剧集记录
                    if (dramaSeriesData) {
                        // alert('存在剧集记录');
                        const { videoSeries } = dramaSeriesData;
                        const currentVideoSeries = videoSeries.find(item => item.id === currentVideo.base62Id);

                        // 存在正片记录
                        if (currentVideoSeries) {
                            // alert('存在正片记录');
                            // 更新最新时间
                            currentVideoSeries.createTime = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss');
                            dramaSeriesData.createTime = new Date();
                            dramaSeriesData.total = positive.length;
                            setlocal('history', historyObj);
                        } else {
                            // 不存在正片记录
                            // alert('不存在正片记录，创建新正片');

                            const data = {
                                id: currentVideo.base62Id, // base62Id格式
                                type: 'positive', // 默认正片 positive / 花序 gags
                                title: currentVideo.title2 ? currentVideo.title2 : currentVideo.title,
                                thumbnail: currentVideo.thumbnails.image[0].url,
                                duration: currentVideo.duration ? i2s(currentVideo.duration) : '00:00',
                                currentTime: '0',
                                createTime: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
                            };

                            videoSeries.push(data);
                            setlocal('history', historyObj);
                        }
                    } else {
                        // 不存在剧集记录，创建新剧集
                        // alert('不存在剧集记录，创建新正片');
                        const data = {
                            id: params.id, // base62Id格式
                            title: dramaSeries.title,
                            like: false,
                            createTime: new Date(),
                            total: positive.length, // 总集数
                            currentIndex: '0', // 观看当前正片索引
                            extText: positive[0]?.extText,
                            posterUrl: dramaSeries.posterUrl || '', // 剧集封面
                            videoSeries: [
                                // 视频列表
                                {
                                    id: currentVideo.base62Id, // base62Id格式
                                    type: 'positive', // 默认正片 positive / 花序 gags
                                    title: currentVideo.title2 ? currentVideo.title2 : currentVideo.title,
                                    thumbnail: currentVideo.thumbnails.image[0].url,
                                    duration: currentVideo.duration ? i2s(currentVideo.duration) : '00:00',
                                    currentTime: '0',
                                    createTime: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
                                },
                            ],
                        };

                        historyObj.push(data);
                        setlocal('history', historyObj);
                    }
                }
            }
        },
        [currentVideo],
    );

    return <VideoWrap content={content} />;
};

Header.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Header);
